import React from 'react';
import ActivityTypeInput from './input';

const config = {
  init: {
    color: '#000',
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Code',
        dataIndex: 'code',
        align: 'center',
        sorter: true
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the activity type
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Activities Types'
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select an Activity Type',
    title: 'Activity Type',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <ActivityTypeInput
            {...props}
            title="Activity Type"
          />
        )
      }
    ]
  }
};

export default config;
